import React from "react"
import PropTypes from "prop-types"

import styles from "./Panel.css"

function Panel({ className, children, ...props }) {
  return (
    <div className={[styles.root, className].join(" ")}>
      <div {...props}>
        {children}
      </div>
    </div>
  )
}

Panel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
Panel.defaultProps = {
  className: "",
  children: null,
}

export default Panel



// WEBPACK FOOTER //
// ./src/shared/components/Panel/Panel.js